import { render, staticRenderFns } from "./PayrollDetails.vue?vue&type=template&id=a8ac1f08&scoped=true"
import script from "./PayrollDetails.vue?vue&type=script&lang=ts"
export * from "./PayrollDetails.vue?vue&type=script&lang=ts"
import style0 from "./PayrollDetails.vue?vue&type=style&index=0&id=a8ac1f08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ac1f08",
  null
  
)

export default component.exports